import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/location-groups/new')({
  beforeLoad: () => {
    throw redirect({ to: '/warehouses/new', replace: true });
  },
});
